import React from 'react';
import { StarIcon } from 'lucide-react';
import { CHECKOUT_URL_ESTANDAR } from '../data/content';
import { Countdown } from './Countdown';
import { OfferCard } from './OfferCard';
interface PricingProps {
  durationHours: number;
  cuposTomados: number;
}
const includes = ['Los 7 tomos del método completo', 'Protocolo de 21 días, día por día', 'Los 5 bonos estratégicos ($60.000)', 'Acceso inmediato en PDF, para siempre'];
export function Pricing({
  durationHours,
  cuposTomados
}: PricingProps) {
  return <section id="oferta" className="bg-forest-950 px-5 py-12 sm:py-20" data-id="element-198" data-mp="1rthxzr7yiuc1">
      <div className="mx-auto max-w-5xl" data-id="element-199" data-mp="25sr1prez7vz4">
        <div className="mx-auto max-w-lg text-center" data-id="element-200" data-mp="25tsogt5cu6wo">
          <span className="inline-flex items-center gap-2 rounded-full bg-clay/20 px-2.5 py-1 text-[0.62rem] font-bold uppercase tracking-[0.12em] text-gold-300 sm:px-3 sm:text-[0.7rem] sm:tracking-[0.15em]" data-id="element-201" data-mp="20slj10qopjt6">
            <span className="relative flex h-2 w-2" data-id="element-202" data-mp="3c93464ou000i">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold-400 opacity-75" data-id="element-203" data-mp="3caeaab5r1jus" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-gold-400" data-id="element-204" data-mp="4t5kzb5xp5xi" />
            </span>
            Oferta en vivo
          </span>
          <h2 className="mt-3 font-display text-xl uppercase tracking-wide text-cream-50 sm:mt-5 sm:text-3xl" style={{
          fontWeight: 700
        }} data-id="element-205" data-mp="9tjuyyr3ipy6">
            Lanzamiento termina en
          </h2>

          <div className="mt-4 sm:mt-6" data-id="element-206" data-mp="3d6uq6n01eg49">
            <Countdown durationHours={durationHours} data-id="element-207" data-mp="3i7irc1hzcdc7" />
          </div>
          <p className="mt-3 text-[0.72rem] text-cream-200/60 sm:text-sm" data-id="element-208" data-mp="3i5pg08wf94xv">Y el precio no vuelve a bajar</p>

          <div className="mt-5 sm:mt-8" data-id="element-209" data-mp="3rxv95lyetsen">
            <div className="flex items-center justify-between text-[0.62rem] font-semibold uppercase tracking-wider text-cream-200/70 sm:text-xs" data-id="element-210" data-mp="3rywt6fxelp8i">
              <span data-id="element-211" data-mp="2ugmzx5hfrk5h">Cupos restantes</span>
              <span className="text-gold-400" data-id="element-212" data-mp="2zgiuyf85o18w">{cuposTomados}% tomados</span>
            </div>
            <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-cream-50/10 sm:mt-2 sm:h-2" role="progressbar" aria-valuenow={cuposTomados} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados" data-id="element-213" data-mp="2rg333zwctslv">
              <div className="h-full rounded-full bg-gold-400" style={{
              width: `${cuposTomados}%`
            }} data-id="element-214" data-mp="2w8mkz922r9wh" />
            </div>
          </div>
        </div>

        <div className="mt-9 text-center sm:mt-14" data-id="element-215" data-mp="28jtrdj8xde51">
          <h3 className="font-display text-[1.6rem] leading-tight text-cream-50 sm:text-4xl" style={{
          fontWeight: 700
        }} data-id="element-216" data-mp="23k7fpe8qw5yc">
            Pack Sin Culpa, Sin Destrozos
          </h3>
          <p className="mt-2 text-[0.8rem] text-cream-200/80 sm:mt-3 sm:text-base" data-id="element-217" data-mp="2dgtzdzpc4qys">
            Todo el método y los 5 bonos estratégicos en un solo pago
          </p>
        </div>

        <div className="relative mx-auto mt-10 max-w-lg sm:mt-12" data-id="element-218" data-mp="3owilkourllyj">
          <span className="absolute -top-7 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap text-[0.6rem] font-bold uppercase tracking-[0.15em] text-gold-400 sm:-top-8 sm:text-[0.65rem]" data-id="element-219" data-mp="3oycwrbg8hzpf">
            <StarIcon className="h-3 w-3 fill-gold-400" aria-hidden="true" data-id="element-220" data-mp="5740ncn1yn3w" />
            La opción elegida por 8 de cada 10 dueños
          </span>
          <OfferCard highlight badge="⭐ Oferta de lanzamiento" title="Pack Sin Culpa, Sin Destrozos" subtitle="7 tomos + 5 bonos estratégicos" oldPrice="$49.990" price="$19.990" includes={includes} note="Al finalizar la compra vas a poder sumar, si querés, el Kit de Emergencia Total™ como complemento opcional." ctaLabel="Sí, lo quiero por $19.990" ctaHref={CHECKOUT_URL_ESTANDAR} data-id="element-221" data-mp="3rhq3p9voyf11" />
        </div>
      </div>
    </section>;
}